import { createFileRoute } from "@tanstack/react-router"
import BuyQuantitiesTab from "~/components/noos-supply-plan/buy-detail/BuyQuantitiesTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/quantities",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("NOOS Supply Plan - Buy Detail - Quantities")
  return <BuyQuantitiesTab />
}
